import api from "../../../lib/api";

export default {
  postDraftBookshelfThumbnailImages(data) {
    return api({
      endpoint: "draft-wall-thumbnail-images",
      path: "my-walls",
      method: "POST",
      body: data
    });
  },
  postDraftBookshelfThumbnailImagesComplete(data) {
    return api({
      endpoint: "draft-wall-thumbnail-images-complete",
      path: "my-walls",
      method: "POST",
      body: data
    });
  },
  putPublicationSettings(data) {
    return api({
      endpoint: "publication-settings",
      path: "my-walls",
      method: "PUT",
      body: data
    });
  },
  getPlaceableStarredContentsList(data) {
    return api({
      endpoint: "stars",
      path: "starred",
      method: "GET",
      queryParams: data
    });
  },
  getPlaceableOwnContentsList(data) {
    return api({
      endpoint: "contents-info-list",
      path: "contents",
      method: "GET",
      queryParams: data
    });
  },
  putContentsOnWall(data) {
    return api({
      endpoint: "edit",
      path: "my-walls",
      method: "PUT",
      body: data
    });
  },
  deleteContentsOnWall(data) {
    return api({
      endpoint: "edit",
      path: "my-walls",
      method: "DELETE",
      queryParams: data
    });
  },
  setStartWallId(data) {
    return api({
      endpoint: "start-wall",
      path: "my-walls",
      method: "POST",
      body: data
    });
  }
};
